export class PlatformUtils {
  static isMac(): boolean {
    if (typeof navigator === 'undefined') return false;
    const platform = navigator.platform || '';
    return /Mac/.test(platform);
  }

  static getModifierSymbol(modifier: 'ctrl' | 'alt' | 'shift'): string {
    const isMac = this.isMac();

    switch (modifier) {
      case 'ctrl':
        return isMac ? '⌘' : 'Ctrl';
      case 'alt':
        return isMac ? '⌥' : 'Alt';
      case 'shift':
        return isMac ? '⇧' : 'Shift';
      default:
        return modifier;
    }
  }

  static formatShortcut(keys: string[]): string {
    return keys
      .map(key => {
        switch (key.toLowerCase()) {
          case 'ctrl':
            return this.getModifierSymbol('ctrl');
          case 'alt':
            return this.getModifierSymbol('alt');
          case 'shift':
            return this.getModifierSymbol('shift');
          default:
            return key.toUpperCase();
        }
      })
      .join(' + ');
  }

  static formatSequentialShortcut(keys: string[]): string {
    return keys.map(key => key.toUpperCase()).join(' → ');
  }
}
